var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chat-container"},[(_setup.basicStore.scene !== 'chat')?_c(_setup.TUIChat):_c('div',{staticClass:"chat-container-chat-scene"},[_c(_setup.MessageList),_c(_setup.ChatEditor)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }